import {
    INCUBO_EVENTS_FETCHING,
    INCUBO_EVENTS_FETCHING_SUCCESS,
    INCUBO_EVENTS_FETCHING_FAILURE,
} from '../actions/types'


const INITIAL_STATE = {
    fetching: false,
    items: [],
    ids: [],
    page: 0,
    pageSize: 10,
    total: 0,
}

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case INCUBO_EVENTS_FETCHING:
            return {
                ...state,
                fetching: true,
            }

        case INCUBO_EVENTS_FETCHING_SUCCESS:
            return {
                ...state,
                items: action.payload.items,
                page: action.payload.pagination.page,
                pageSize: action.payload.pagination.pageSize,
                total: action.payload.pagination.total,
                ids: action.payload.items.map(it => it.id),
                fetching: false,
            }

        case INCUBO_EVENTS_FETCHING_FAILURE:
            return {
                ...state,
                fetching: false,
            }

        default:
            return state
    }
}

export default reducer
